import createFrontApplet from './FrontApplet/createFrontApplet';
import FrontApplet from './FrontApplet/FrontApplet';
import Monitoring from './Monitoring/Monitoring';
import { fpath as _fpath } from './fpath';

// fake exports for generating declarations which are overwritten by module.exports
export const frontApplet = createFrontApplet(window, 'hug');
export const sos = frontApplet;
export const monitoring = new Monitoring(frontApplet);
export const fpath = _fpath;

// add exports to the frontApplet, which is assigned to module.exports
// @ts-expect-error - Adding sos property to frontApplet
frontApplet.sos = frontApplet;
// @ts-expect-error - Adding frontApplet property to itself
frontApplet.frontApplet = frontApplet;
// @ts-expect-error - Adding monitoring property to frontApplet
frontApplet.monitoring = monitoring;
// @ts-expect-error - Adding default property to frontApplet
frontApplet.default = frontApplet;
// @ts-expect-error - Adding fpath property to frontApplet
frontApplet.fpath = fpath;

declare global {
	interface Window {
		sos: FrontApplet;
		sosMonitoring: Monitoring;
	}
}

window.sos = frontApplet;
window.sosMonitoring = monitoring;

export default frontApplet;
module.exports = frontApplet;
